import Container from "@/components/common/Container";
import Image from "next/image";

const OurService = (data) => {
  const { title, ourServiceRightList, description } = data.ourService;
  return (
    <Container Container large className="bg-primary-black">
      <div className="flex flex-col md:flex-row pt-36 pb-14 md:pt-20 md:pb-20 xl:py-40">
        <div className="md:w-1/2">
          <div className="relative md:top-28 md:sticky">
            <h2 className="text-white text-4xl pb-10 md:pb-6 w-full md:w-2/3 lg:text-6xl font-medium mb-0 md:leading-tight lg:leading-tight">
              <span>{title}</span>
            </h2>
            <p className="text-white text-justify font-normal text-base md:text-sm lg:text-base w-full md:w-3/4 pb-10 md:pb-0">
              <span dangerouslySetInnerHTML={{ __html: description }}></span>
            </p>
          </div>
        </div>
        <div className="pt-4 md:pt-0 md:w-1/2">
          {ourServiceRightList.map((values, index) => (
            <div key={values.title}>
              <div
                className={`flex pb-7 md:pb-10 ${
                  ourServiceRightList.length - 1 === index ? "pb-0" : "lg:pb-20"
                }`}
              >
                <div className="mr-4 md:mr-8">
                  <div className="w-10 md:w-12 lg:w-20">
                    <Image
                      alt={values.alt}
                      height={70}
                      src={values.img}
                      title={values.alt}
                      width={70}
                    />
                  </div>
                </div>
                <div>
                  <h3 className="text-white mb-3 md:mb-4 mb-md-4 text-lg lg:text-2xl font-semibold">
                    <span>{values.title}</span>
                  </h3>
                  <div className="text-white text-base text-justify font-normal mb-0">
                    <span
                      dangerouslySetInnerHTML={{ __html: values.description }}
                    ></span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </Container>
  );
};
export default OurService;
